/**
 * The item a key moves the focus to inside an open menu (WAI-ARIA menu pattern): the arrows step
 * and wrap, Home and End jump. Null for any other key, which the menu leaves to the browser.
 */
export function nextMenuIndex(current: number, key: string, count: number): number | null {
  if (count === 0) return null;
  if (key === 'ArrowDown') return (current + 1) % count;
  if (key === 'ArrowUp') return (current - 1 + count) % count;
  if (key === 'Home') return 0;
  if (key === 'End') return count - 1;
  return null;
}
